import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PaymentTagsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPaymentTag = (data): any => action(types.CREATE_PAYMENT_TAG_REQUESTED, data);

export const updatePaymentTag = (data): any => action(types.UPDATE_PAYMENT_TAG_REQUESTED, data);

export const deletePaymentTag = (paymentTagId): any => action(types.UPDATE_PAYMENT_TAG_REQUESTED, paymentTagId);

export const getPaymentTag = (paymentTagId): any => action(types.GET_PAYMENT_TAG_REQUESTED, paymentTagId);

export const getAllPaymentTags = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PAYMENT_TAGS_REQUESTED, {
  pagination,
  compile,
});

export const selectPaymentTag = (paymentTagId): any => action(types.SELECT_PAYMENT_TAG_REQUESTED, {
  currentPaymentTagId: paymentTagId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPaymentTagPending: (payload): any => action(types.CREATE_PAYMENT_TAG_PENDING, payload),
  createPaymentTagSuccess: (response): any => {
    const currentPaymentTag = response.entities.paymentTags[response.result];
    return action(types.CREATE_PAYMENT_TAG_SUCCESS, {
      paymentTagsById: response.entities.paymentTags,
      currentPaymentTagId: response.result,
    });
  },
  updatePaymentTagPending: (payload): any => action(types.UPDATE_PAYMENT_TAG_PENDING, payload),
  updatePaymentTagSuccess: (response): any => action(types.UPDATE_PAYMENT_TAG_SUCCESS, {
    paymentTagsById: response.entities.paymentTags,
    currentPaymentTagId: response.result,
  }),
  updatePaymentTagFailed: (error): any => action(types.UPDATE_PAYMENT_TAG_FAIL, {
    backendErrors: error,
  }),
  deletePaymentTagPending: (): any => action(types.UPDATE_PAYMENT_TAG_PENDING, {}),
  deletePaymentTagSuccess: (response, userId): any => {
    localStorage.set(userId, { currentPaymentTagId: null });
    history.push('/paymentTags');

    return action(types.DELETE_PAYMENT_TAG_SUCCESS, {
      currentPaymentTagId: response,
    });
  },
  getPaymentTagPending: (): any => action(types.GET_PAYMENT_TAG_PENDING, {}),
  getPaymentTagSuccess: (response): any => action(types.GET_PAYMENT_TAG_SUCCESS, {
    paymentTagsById: response.entities.paymentTags,
    currentPaymentTagId: response.result,
  }),
  getPaymentTagFailed: (error): any => action(types.GET_PAYMENT_TAG_FAIL, {
    backendErrors: error,
  }),
  deletePaymentTagFailed: (error): any => action(types.UPDATE_PAYMENT_TAG_FAIL, {
    backendErrors: error,
  }),
  getAllPaymentTagsPending: (pagination): any => action(types.GET_ALL_PAYMENT_TAGS_PENDING, { pagination }),
  getAllPaymentTagsSuccess: (response, meta): any => action(types.GET_ALL_PAYMENT_TAGS_SUCCESS, {
    paymentTagsById: response.entities.tags,
    paymentTagIds: response.result,
    meta,
  }),
  getAllPaymentTagsFailed: (error): any => action(types.GET_ALL_PAYMENT_TAGS_FAIL, {
    backendErrors: error,
  }),
  createPaymentTagFailed: (error): any => action(types.CREATE_PAYMENT_TAG_FAIL, {
    backendErrors: error,
  }),
};

export default null;
